import angular from 'angular'
import template from './template.html'

function NominasCarganominaasalariadosImportarComponent($dialogParams, dialog, $dialog, FinanzasTablaRelacional) {
  let $ctrl = this;
  $ctrl.catalogos = {
    Empresas: $dialogParams['Empresas'],
  };
  $ctrl.input = '';
  $ctrl.options = {
    companies: $dialogParams['Seleccionadas'] || [],
    search: [],
    company_filter: null,
    byID: $dialogParams['ID_Nomifan'] || false,
    decodeID: true,
  };
  $ctrl.valid = undefined;

  $ctrl.$decode = function () {
    if ($ctrl.input === '') {
      $ctrl.valid = undefined;
      return;
    }

    let valid = 0;
    try {
      $ctrl.options.search = [];
      angular.forEach($ctrl.input.split('\n'), function (row) {
        let data = row.split('\t');
        if (data.length === 2) {
          data.unshift('');
        }
        data = {
          id: data[0] && data[0] !== '' ? data[0] : null,
          name: data[1] && data[1] !== '' ? data[1].replace(/[0123456789.]/g, ' ').trim() : null,
          income: data[2] ? parseFloat(data[2].replace(/[^0-9\.]/g, '')) : null,
          original: row,
        };
        data.valid = data.income > 0 && (data.id !== null || data.name !== null);
        valid += data.valid ? 1 : 0;
        $ctrl.options.search.push(data);
      });
      $ctrl.valid = valid > 0;
    } catch (error) {
      $ctrl.valid = false;
    }
    $ctrl.input = valid ? '' : $ctrl.input;
  };

  $ctrl.$clear = function () {
    $ctrl.input = '';
    $ctrl.valid = undefined;
    $ctrl.options.search = [];
  };

  $ctrl.$companySelect = function (selectAll) {
    $ctrl.options.companies.length = 0;
    if (selectAll) {
      $ctrl.catalogos.Empresas.forEach(function (company) {
        $ctrl.options.companies.push(company.ID);
      });
    }
  };

  $ctrl.$companyToggle = function (company) {
    if ($ctrl.options.companies.indexOf(company) >= 0) {
      $ctrl.options.companies.splice($ctrl.options.companies.indexOf(company), 1);
    } else {
      $ctrl.options.companies.push(company);
    }
  };

  $ctrl.$process = function () {
    if ($ctrl.options.companies.length === 0) {
      alert('Es necesario especificar al menos una empresa.');
      return;
    }

    let rows = $ctrl.options.search.filter(function (row) {
      return row.valid;
    }).map(function (row) {
      return [row.id ? Pad(row.id) : '', row.name, row.income];
    });
    $ctrl.loading = true;
    FinanzasTablaRelacional.search(rows, $ctrl.options.byID, $ctrl.options.companies).then(function (data) {
      let Empresas = {};
      $ctrl.catalogos.Empresas.forEach(function (empresa) {
        if ($ctrl.options.companies.indexOf(empresa['ID_Empresa']) >= 0)
          Empresas[empresa['ID_Empresa']] = {
            ID: empresa.ID_Empresa,
            Descripcion: empresa.Nombre,
          };
      });
      $dialog.show('nominas.cargaNominaAsalariados.vincular', {data: data, companies: Empresas})
        .then(dialog.resolve);
    }).finally(function () {
      $ctrl.loading = false;
    });

  };

  function Pad(string) {
    return Number(string) ? string.pad(5, '0') : string;
  }

  $ctrl.cancel = function () {
    dialog.reject();
  };
}

angular.module('nominas.carganominaasalariados')
  .controller('NominasCarganominaasalariadosImportar', NominasCarganominaasalariadosImportarComponent)
  .config(($dialogProvider) => {
    $dialogProvider.dialog('nominas.cargaNominaAsalariados.importar', {
      controller: 'NominasCarganominaasalariadosImportar',
      template: template,
      controllerAs: '$ctrl',
      cancelable: false,
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/carganominaasalariados/components/importar/component.js